import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})


export class UserMessagesService {

    private errorMessageSource = new Subject<string>();
    private errorMessagesSource = new Subject<string[]>();
    errorMessage$ = this.errorMessageSource.asObservable();
    errorMessages$ = this.errorMessagesSource.asObservable();
    private successMessageSource = new Subject<string>();
    private successMessagesSource = new Subject<string[]>();
    successMessage$ = this.successMessageSource.asObservable();
    successMessages$ = this.successMessagesSource.asObservable();

    private _snackBarRef: MatSnackBarRef<any>;

    constructor(private _snackBarMessage: MatSnackBar) { }

    setErrorMessage(message: string) {
        this.errorMessageSource.next(message);
    }

    clearErrorMessage(): void {
        this.errorMessageSource.next();
    }

    setErrorMessages(messages: string[]) {
        this.errorMessagesSource.next(messages);
    }

    clearErrorMessages(): void {
        this.errorMessagesSource.next([]);
    }

    setSuccessMessage(message: string) {
        this.successMessageSource.next(message);
    }

    clearSuccessMessage(): void {
        this.successMessageSource.next();
    }

    clearAll() {
        this.clearErrorMessage();
        this.clearErrorMessages();
        this.clearSuccessMessage();
        if (this._snackBarRef) {
            this._snackBarRef.dismiss();
        }
    }



    showSnackBarSuccessMessage(message: string, durationInMs: number = null, onDismissCallback: () => any = null) {
        const action = durationInMs ? null : "סגור";
        this._snackBarRef = this._snackBarMessage.open(message, action, { panelClass: "snack-bar-success", duration: durationInMs });

        if (onDismissCallback) {
            this._snackBarActionCallback(onDismissCallback);
        }

        return this._snackBarRef;
    }

    showSnackBarErrorMessage(message: string, durationInMs: number = null, onDismissCallback: () => any = null) {
        const action = durationInMs ? null : "סגור";
        this._snackBarRef = this._snackBarMessage.open(message, action, { panelClass: "snack-bar-error", duration: durationInMs });

        if (onDismissCallback) {
            this._snackBarActionCallback(onDismissCallback);
        }

        return this._snackBarRef;
    }

    private _snackBarActionCallback(onDismissCallback: () => any): void {
        const dismissSubscription = this._snackBarRef.onAction().subscribe(() => {
            dismissSubscription.unsubscribe();
            onDismissCallback();
        });
    }

    clearSnackBarMessage(): void {
        if (this._snackBarRef) {
            this._snackBarRef.dismiss();
        }
    }

}